import "animate.css";
import React, { useEffect, useMemo } from "react";
import { Button, Container, Form } from "react-bootstrap";
import { FaCheckCircle, FaSignOutAlt } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { PAGINE, TIPOLOGIE } from ".";
import HeaderSenologia from "./senologia/components/HeaderSenologia";
import HeaderColon from "./coloneRetto/components/HeaderColon";
import PageContainer from "../components/PageContainer";

const RisultatoGradimento = ({ tipologia }) => {
    const navigate = useNavigate()
    const location = useLocation()

    const header = useMemo(() => {
        if (tipologia) {
            switch (tipologia.KID) {
                case TIPOLOGIE.SENOLOGIA.KID: return <HeaderSenologia subtitle="" />;
                case TIPOLOGIE.COLON_RETTO.KID: return <HeaderColon subtitle="" />;
                default: return
            }
        }
    }, [tipologia])

    const termina = (e) => {
        e.preventDefault();
        navigate(`/${tipologia.URL}${PAGINE.HOME_GRADIMENTO.URL}`)
    }

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return <PageContainer tipologia={tipologia}>
        <Container className="main-container">
            <div className="mt-4 p-md-4" style={{ borderRadius: 20, backgroundColor: 'white' }}>
                {header}
                <div className={`text-left p-md-4 `}>
                    <Form onSubmit={(e) => termina(e)}>
                        <h1 style={{ color: 'hotpink' }}>Grazie per aver compilato il questionario di gradimento</h1>
                        <Form.Group className="form-group text-left bg-light border">
                            <div className="icon-label">
                                <FaCheckCircle color="green" className="mt-2" />
                                <label>Scheda salvata con numero <strong>{location.state.NUMERO_ANNO}</strong></label>
                            </div>
                        </Form.Group>
                        <div className="d-grid gap-2">
                            <Button type="submit" variant="outline-primary" className="btn-lg"><FaSignOutAlt /> Termina</Button>
                        </div>
                    </Form>
                </div>
            </div>
        </Container>
    </PageContainer>
}

export default RisultatoGradimento;